/** Copyright © 2024 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/

import type { ValueType } from 'hems/common/utils';

export const HOME_APPLIANCE = 'home-appliance' as const;

export const APPLIANCE_TYPE = {
  HEAT_PUMP: 'HeatPump',
  AIR_CONDITIONER: 'Air Conditioner',
  SMART_PLUG: 'Smart Plug',
  TV: 'TV',
} as const;

export type ApplianceTypeValue = ValueType<typeof APPLIANCE_TYPE>;

export const SMARTTHINGS_TEMPERATURE_UNIT = {
  CELSIUS: 'C',
  FAHRENHEIT: 'F',
};

export type SmartThingsTemperatureUnit = ValueType<typeof SMARTTHINGS_TEMPERATURE_UNIT>;

export const APPLIANCE_STATUS = {
  ON: 'On',
  OFF: 'Off',
} as const;

export type ApplianceStatus = ValueType<typeof APPLIANCE_STATUS>;

export const SMARTTHINGS_COMPONENT_TYPE = {
  MAIN: 'main',
  INDOOR: 'indoor',
} as const;

export type SmartThingsComponentType = ValueType<typeof SMARTTHINGS_COMPONENT_TYPE>;

export const SMARTTHINGS_HEALTH_STATUS = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
} as const;

export type SmartThingsHealthStatus = ValueType<typeof SMARTTHINGS_HEALTH_STATUS>;

export const APPLIANCE_NAME_KEY: { [k in ApplianceTypeValue]: string } = {
  [APPLIANCE_TYPE.HEAT_PUMP]: 'device.heat_pump',
  [APPLIANCE_TYPE.AIR_CONDITIONER]: 'common.air_conditioner',
  [APPLIANCE_TYPE.SMART_PLUG]: 'common.smart_plug',
  [APPLIANCE_TYPE.TV]: 'common.tv',
} as const;

export const APPLIANCE_CONTROL_TYPE = {
  MODE: 'mode',
  TEMPERATURE: 'temperature',
} as const;

export type ApplianceControlType = ValueType<typeof APPLIANCE_CONTROL_TYPE>;

export const SMARTTHINGS_CONTROL_STATUS = {
  ACCEPTED: 'ACCEPTED',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
} as const;

export type SmartThingsControlStatus = ValueType<typeof SMARTTHINGS_CONTROL_STATUS>;
